import React from "react";
import { regular, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Tab, Tabs } from "@mui/material";
import "./TaskTimeline.styles.css";
import useWindowSize from "../../hooks/useWindowSize";
import { useDispatch } from "react-redux";
import moment from "moment";
import instance from "../../utils/axios";
import { apiErrorHandler } from "../../utils/errorHandler";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import { getApiUrl } from "../../utils/apiUrls";
import CustomToolTip from "../../components/custom-tooltip/CustomTooltip.component";
import ProgressBar from "../../components/progress-bar/ProgressBar.component";
import { ReactComponent as EmptyData } from "../../assets/images/global/empty-data.svg";
import { isValidUrl, isSecureUrl, sanitiseInput } from "../../utils/helperFn";
import { useNavigate } from "react-router-dom";

function EventTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`eventtabpanel-${index}`}
      aria-labelledby={`event-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className="cm-timeline-tab-content-inner">{children}</div>
      )}
    </div>
  );
}

const TaskTimelineContainer = ({
  eventId,
  taskData,
  joinModalData,
  joinModalDataHandler,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const windowSize = useWindowSize();

  const [timelineStatus, setTimelineStatus] = React.useState({
    status: false,
    data: {
      definedTasks: null,
      otherTasks: null,
    },
    fetchData: true,
    isLoading: false,
  });

  const [tabValue, setTabValue] = React.useState(0);
  const [scrollPosition, setScrollPosition] = React.useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    position <= 64 && setScrollPosition(position);
  };

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    fetchTimeline(newValue);
  };

  const handleModalOpen = (e) => {
    if (timelineStatus.isLoading) return;

    e.stopPropagation();
    setTimelineStatus({
      ...timelineStatus,
      status: !timelineStatus.status,
    });
  };

  React.useEffect(() => {
    document.body.style.overflow = timelineStatus.status ? "hidden" : "auto";

    // timelineStatus.status && timelineStatus.fetchData && !timelineStatus.isLoading && fetchTimeline();
    if (timelineStatus.status && timelineStatus.fetchData) {
      fetchTimeline();
    }

    // eslint-disable-next-line
  }, [timelineStatus]);

  const handleClose = () => {
    if (timelineStatus.isLoading) return;

    setTimelineStatus({
      ...timelineStatus,
      status: false,
      fetchData: true,
      data: {
        definedTasks: null,
        otherTasks: null,
      },
    });
    setTabValue(0);
  };

  const tooltipBodyForOtherTask = () => {
    // for interview and gd
    return t("yet_to_be_scheduled");
  };

  const tooltipBodyForScheduledTask = (innerEl) => {
    if (innerEl.taskMode === "OFFLINE") {
      if (["INTERVIEW", "GROUP_DISCUSSION"].includes(innerEl.taskType)) {
        // OFFLINE INTERVIEW GROUP_DISCUSSION
        if (!!innerEl?.location) {
          return `${
            innerEl.taskType === "INTERVIEW"
              ? t("interview_location")
              : t("gd_location")
          }: ${innerEl.location}`;
        } else {
          return t("yet_to_be_scheduled");
        }
      } else {
        // OFFLINE TEST
        return t("join_in_person");
      }
    } else {
      // ONLINE
      if (
        !!innerEl.taskLink ||
        (innerEl.taskType !== "INTERVIEW" &&
          innerEl.taskType !== "GROUP_DISCUSSION" &&
          !moment().isBefore(innerEl.taskStartDate))
      ) {
        return t("join") + " / " + t("launch");
      } else {
        return t("yet_to_be_unlocked");
      }
    }
  };

  const fetchTimeline = async (tabValue = 0) => {
    try {
      // setTimelineStatus({
      //     ...timelineStatus,
      //     isLoading: true
      // })
      // const token = getToken();
      const token = localStorage.getItem("token");
      // const res = await instance.get(`${getApiUrl('getCandidateTaskTimeline')}?eventId=${eventId}`, {
      //     headers: {
      //         "Authorization" : `Bearer ${token}`,
      //     }
      // });

      const res = await instance.get(
        `${getApiUrl(
          tabValue === 0 ? "getScheduledTaskTimeline" : "getOtherTaskTimeline"
        )}?eventId=${eventId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const dataToMap = {};
      if (tabValue === 0) {
        dataToMap.definedTasks = !!res.data ? res.data : [];
      } else {
        dataToMap.otherTasks = [
          {
            title: t("no_defined_schedules"),
            data: !!res.data ? res.data : [],
          },
        ];
      }

      setTimelineStatus({
        ...timelineStatus,
        data: {
          ...timelineStatus.data,
          ...dataToMap,
          // definedTasks: !!res.data ? res.data : [],
          // otherTasks: (res.data.otherTasks && res.data.otherTasks.length > 0) ? [
          //     {
          //         title: t('no_defined_schedules'),
          //         data: res.data.otherTasks ? res.data.otherTasks : []
          //     }
          // ]
          // : []
        },
        fetchData: false,
        isLoading: false,
      });

      // setTimelineStatus({
      //     ...timelineStatus,
      //     data: {
      //         definedTasks: (res.data.scheduledTasks && res.data.scheduledTasks.length > 0) ? dateWiseGroup(res.data.scheduledTasks) : [],
      //         otherTasks: (res.data.otherTasks && res.data.otherTasks.length > 0) ? [
      //             {
      //                 title: t('no_defined_schedules'),
      //                 data: res.data.otherTasks ? res.data.otherTasks : []
      //             }
      //         ]
      //         : []
      //     },
      //     fetchData: false,
      //     isLoading: false
      // })
    } catch (error) {
      const dataToMap = {};
      if (tabValue === 0) {
        dataToMap.definedTasks = [];
      } else {
        dataToMap.otherTasks = [
          {
            title: t("no_defined_schedules"),
            data: [],
          },
        ];
      }

      setTimelineStatus({
        ...timelineStatus,
        isLoading: false,
        fetchData: false,
        data: {
          ...dataToMap,
        },
      });
      const errObj = apiErrorHandler(error);

      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  };

  const getHoganTteTaskLink = async (taskId, index, taskType) => {
    try {
      const token = localStorage.getItem("token");
      const res = await instance.post(
        getApiUrl("getThirdPartyLoginData"),
        {
          taskId,
          eventId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (taskType === "TTE_ASSESSMENTS") {
        if (!!res.data.url) {
          // Security: Validate URL to prevent Open Redirect (CWE-601)
          const secureUrl = isSecureUrl(res.data.url, dispatch, t);
          if (!secureUrl) return;
          // Safe: URL has been validated above
          window.open(secureUrl, "_blank");
        }
        return;
      }
      if (res.data) {
        // Security: Validate URL to prevent Open Redirect (CWE-601)
        const secureUrl = isSecureUrl(res.data.url, dispatch, t);
        if (!secureUrl) {
          return;
        }
        
        const params = res.data;
        const form = document.getElementById(`other-task-` + index);
        form.method = 'POST';
        // Safe: URL has been validated above
        form.action = secureUrl;   

        for (const key in params) {
          const input = document.createElement('input');
          if(input.name != 'url') {
            input.type = 'hidden';
            input.name = key;
            input.value = params[key];
  
            form.appendChild(input);
          }
        }
        document.body.appendChild(form);      
        form.submit();
        form.innerHTML = '';

        return;
      }

      if (res.data.status === "ERROR") {
        throw Error(res.data.message);
      }
    } catch (error) {
      const errObj = apiErrorHandler(error);

      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  }

  const getTaskLink = async (taskId) => {
    try {
      const token = localStorage.getItem("token");

      const res = await instance.post(
        getApiUrl("getTaskLink"),
        {
          taskId,
          eventId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
        // Security: Validate URL to prevent Open Redirect (CWE-601)
        const secureUrl = isSecureUrl(res.data.testLink, dispatch, t);
        if (!secureUrl) return;
        
        // Safe: URL has been validated above
        window.open(secureUrl, "_blank");
      }

      if (res.data.status === "ERROR") {
        throw Error(res.data.message);
      }
    } catch (error) {
      const errObj = apiErrorHandler(error);
      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  };

  const onClickEvent = (link, taskId, taskStartDate) => {
    if (!!link) {
      let showPopup = !moment().isSameOrAfter(
        moment(taskStartDate).subtract(15, "minutes")
      );
      if (showPopup) {
        joinModalDataHandler({
          ...joinModalData,
          customDialogBoxToggle: true,
          link,
          taskStartDate,
        });
      } else {
        // Security: Validate URL to prevent Open Redirect (CWE-601)
        const secureUrl = isSecureUrl(link, dispatch, t);
        if (!secureUrl) return;
        // Safe: URL has been validated above
        window.open(secureUrl, "_blank");
      }
    } else {
      if (!moment().isBefore(taskStartDate)) {
        getTaskLink(taskId);
      }
    }
  };

  const showTaskDate = (el) => {
    if (el?.taskControl === "LOCK" || el?.block){
      return t("yet_to_be_unlocked");
    }
    let dateText = moment().isAfter(moment(el.taskStartDate))
      ? `${t("deadline")}:`
      : `${t("starts_on")}:`;
    let taskDate = moment().isAfter(moment(el.taskStartDate))
      ? moment(el.taskEndDate).format("MMM DD YYYY @ hh:mm A")
      : moment(el.taskStartDate).format("MMM DD YYYY @ hh:mm A");

    return `${dateText} ${taskDate}`;
  };

  const iconLinkHandler = (innerEl) => {
    // FOR SCHEDULE TASK
    if(innerEl.taskType==="FEEDBACK_SURVEY") {
      let link
      if (!!innerEl?.approverLink) {
        link = innerEl?.approverLink
      }
      else if (!!innerEl?.nominationLink) {
        link = innerEl?.nominationLink
      }
      else {
        link = innerEl?.selfLink
      }
      return (
        <>
          <FontAwesomeIcon
            icon={regular("external-link")}
            className={`cm-sm-txt p-2 ${!(innerEl?.block ||
              innerEl.taskControl === "LOCK") && moment().isBetween(moment(innerEl.taskStartDate), moment(innerEl.taskEndDate)) ? "cm-pointer text-blue-gray-700" : "cm-pointer-none cm-disable-icon-color"
              }`}
            onClick={() =>
              !(innerEl?.block ||
                innerEl.taskControl === "LOCK") && moment().isBetween(moment(innerEl.taskStartDate), moment(innerEl.taskEndDate)) && (() => {
                // Security: Validate URL to prevent Open Redirect (CWE-601)
                const secureUrl = isSecureUrl(link, dispatch, t);
                if (!secureUrl) return;
                // Safe: URL has been validated above
                window.open(secureUrl, "_blank");
              })()
            }
          />
        </>
      )
    }
    if (innerEl.taskMode === "OFFLINE" &&
      ["INTERVIEW", "GROUP_DISCUSSION"].includes(
        innerEl.taskType
      )) {
      return (
        <FontAwesomeIcon
          icon={
            isValidUrl(innerEl.location)
              ? regular("external-link")
              : regular("location-dot")
          }
          className={`cm-sm-txt p-2 ${isValidUrl(innerEl.location) && innerEl.taskControl !== "LOCK" && moment().isBetween(moment(innerEl.taskStartDate), moment(innerEl.taskEndDate)) ? "cm-pointer text-blue-gray-700" : "cm-pointer-none cm-disable-icon-color"
            }`}
          onClick={() =>
            isValidUrl(innerEl.location) &&
            moment().isBetween(moment(innerEl.taskStartDate), moment(innerEl.taskEndDate)) && (() => {
              // Security: Validate URL to prevent Open Redirect (CWE-601)
              const secureUrl = isSecureUrl(innerEl.location, dispatch, t);
              if (!secureUrl) return;
              // Safe: URL has been validated above
              window.open(secureUrl, "_blank");
            })()
          }
        />)
    }
    
    if(innerEl.taskMode === "AI" && innerEl.slotType && !(moment().isSameOrAfter(moment(innerEl.taskStartDate)) && moment().isSameOrBefore(moment(innerEl.taskEndDate)))) {
      return <FontAwesomeIcon
          icon={regular("arrow-up-right-from-square")}
          className={`cm-sm-txt p-2 cm-pointer-none cm-disable-icon-color`}
      />;
    }

    return (
      <>
        <FontAwesomeIcon
          icon={regular("arrow-up-right-from-square")}
        className={`cm-sm-txt p-2  ${
          !(innerEl?.block ||
          innerEl.taskControl === "LOCK") &&
          (!!innerEl.taskLink ||
            (innerEl.taskType !== "INTERVIEW" &&
              innerEl.taskType !== "GROUP_DISCUSSION" &&
              !moment().isBefore(innerEl.taskStartDate)))
            ? "text-blue-gray-700 bg-blue-gray-50 cm-btn-radius cm-pointer"
            : " cm-pointer-none cm-disable-icon-color"
        }`}
      />
    </>
    )
  }

  const preTextData = (data) => {
    if (!!data.approverLink) {
      return t("approve_providers")
    }
    else if (!!data.nominationLink) {
      return t("add_provider")
    }
    else {
      return t("provide_feedback")
    }
  }
  
  const loadScheduledTasks = () => {
    const scheduleStructure = [];

    for (let key in timelineStatus.data.definedTasks) {
      const getTimeStr = key / 1000;
      const evStructure = (
        <div className="cm-timeline-item" key={key}>
          <p className="text-blue-gray-700 fw-semibold cm-xs-txt">
            {moment.unix(getTimeStr).format("dddd / MMM DD YYYY")}
          </p>
          {timelineStatus.data.definedTasks[key].map((innerEl, index) => {
            return(
            <div
              className={`cm-timeline-inner-item bg-white position-relative d-flex`}
              key={"inner" + innerEl.taskId}
            >
              <div className="flex-grow-1">
                <div className="d-flex">
                  <p className="mb-2 cm-sm-txt text-blue-800">
                    {innerEl.taskType === "FEEDBACK_SURVEY"?preTextData(innerEl) + "- ":""}{innerEl.taskName}
                  </p>
                  {innerEl.taskControl === "LOCK" ? (
                    <FontAwesomeIcon
                      icon={solid("lock")}
                      className="text-blue-gray-500 mx-2 ps-1"
                    />
                  ) : null}
                </div>
                {!(innerEl?.taskControl === "LOCK" || innerEl?.block) && <p className="mb-1 cm-xs-txt text-blue-gray-500">
                  {innerEl.taskType === "ASSESSMENT"
                    ? t("test")
                    : t(innerEl.modeType.toLowerCase())}
                </p>}
                <p className="mb-0 cm-xs-txt text-blue-gray-500">
                  {showTaskDate(innerEl)}
                </p>
              </div>
              <div
                className="my-auto"
                onClick={() => {
                  if (!(innerEl?.block || innerEl.taskControl === "LOCK") && innerEl.taskType !== "FEEDBACK_SURVEY") {
                    
                    if(innerEl.taskMode === "AI" && innerEl.slotType && !(moment().isSameOrAfter(moment(innerEl.taskStartDate)) && moment().isSameOrBefore(moment(innerEl.taskEndDate)))) {
                      return;
                    }
                    
                    ["ONLINE", "AI" ].includes(innerEl.taskMode) &&
                      onClickEvent(
                        innerEl.taskLink,
                        innerEl.taskId,
                        innerEl.taskStartDate
                      );
                  }
                }}
              >
                <CustomToolTip
                  disableTooltip={innerEl.taskControl === "LOCK" || innerEl?.block}
                  title={
                    <p className="mb-0 cm-xs-txt fw-medium">
                      {tooltipBodyForScheduledTask(innerEl)}
                    </p>
                  }
                >
                <div>
                  {iconLinkHandler(innerEl)}
                </div>
                </CustomToolTip>
              </div>
            </div>
          )})}
        </div>
      );

      scheduleStructure.push(evStructure);
    }

    return scheduleStructure;
  };

  const loadTaskCat = (data) => {
    if (data.taskMode === null)
      return data.taskType === "ASSESSMENT"
        ? t("test")
        : t(data.taskType.toLowerCase());

    if (["online", "offline"].includes(data.taskMode?.toLowerCase())) {
      if (!!data?.modeType) {
        return data?.modeType === "ASSESSMENT"
          ? t("test")
          : t(data.modeType.toLowerCase());
      } else {
        return data.taskType === "ASSESSMENT"
          ? t("test")
          : t(data.taskType?.toLowerCase());
      }
    }
  };

  const handleOtherTaskClick = (innerEl, index) => {
    // FOR ONLY TEST, HOGAN_ASSESSMENTS, TTE
    if (
      innerEl?.block ||
      innerEl.taskControl === "LOCK" ||
      innerEl.taskMode !== "ONLINE"
    ) {
      return;
    }
    if (["HOGAN_ASSESSMENTS","TTE_ASSESSMENTS"].includes(innerEl.taskType)) {
      if (!moment().isAfter(taskData.startDate)) return;
      return getHoganTteTaskLink(innerEl.taskId, index);
    }

    if (
      innerEl.candidateWiseSchedule ||
      !moment().isAfter(taskData.startDate)
    ) {
      return;
    }
    getTaskLink(innerEl.taskId);
  };

  const handleOtherTaskClass = (innerEl) => {
    if (
      innerEl.block ||
      innerEl.taskControl === "LOCK" ||
      innerEl.taskMode === "OFFLINE"
    ) {
      return true;
    }
    if(["HOGAN_ASSESSMENTS"].includes(innerEl.taskType)){
      return !moment().isAfter(taskData.startDate);
    }
    if(innerEl.candidateWiseSchedule || !moment().isAfter(taskData.startDate)){
      return true
    }
    return false;
  };
  const testToolBody = (innerEl) => {
    // FOR ONLY TEST
    if (innerEl.taskMode !== "ONLINE") {
      return t("this_task_is_to_be_attended_offline_in_person");
    }

    if (taskData?.candidateWiseSchedule) {
      return t("yet_to_be_scheduled");
    }
    if (moment().isAfter(taskData.startDate)) {
      return t("join") + " / " + t("launch");
    }

    return t("yet_to_be_unlocked");
  };

  const showTaskType = (data) => {
    if (data.taskType === "ASSESSMENT") {
      return t("test");
    } 
    if (data.taskType === "HOGAN_ASSESSMENTS") {
      return t("hogan_candidate_tasktype");
    }
    return t(data.modeType.toLowerCase());
  };

  return (
    <>
      {windowSize.isMobile ? (
        <div
          className="cm-task-timeline-mob-trigger position-fixed bg-text-gray d-flex align-items-center justify-content-center bg-blue-gray cm-pointer"
          onClick={handleModalOpen}
        >
          <FontAwesomeIcon
            icon={regular("calendar-range")}
            className="text-white"
          />
        </div>
      ) : null}
      <div
        className={`cm-task-timeline-container position-fixed ${
          timelineStatus.status ? "cm-task-timeline-active" : ""
        }`}
        onClick={handleClose}
        style={{
          height: `calc(100vh - ${121 - scrollPosition}px)`,
          top: `${121 - scrollPosition}px`,
        }}
      >
        {!windowSize.isMobile ? (
          <div
            className="cm-task-timeline-trigger bg-blue-gray-700 position-absolute text-white d-flex align-items-center cm-pointer"
            onClick={handleModalOpen}
          >
            <div className="cm-task-timeline-icon bg-blue-gray-700 text-white d-flex align-items-center justify-content-center">
              <FontAwesomeIcon icon={regular("chevron-left")} />
            </div>
            <div className="cm-task-timeline-trigger-content bg-blue-gray-700 text-white">
              <FontAwesomeIcon
                icon={regular("calendar-range")}
                className="d-block mx-auto mb-3"
              />
              <p className="cm-xs-txt fw-semibold text-uppercase">
                {t("view_task_timeline")}
              </p>
            </div>
          </div>
        ) : null}
        <div
          className="cm-task-timeline-content-wrap position-absolute position-absolute bg-blue-gray-50 py-4 ps-4 d-flex flex-column"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="cm-task-timeline-content-header position-relative pe-4">
            <div
              className="cm-task-timeline-close d-flex align-items-center justify-content-center bg-blue-gray-50 cm-pointer"
              onClick={handleClose}
            >
              {windowSize.isMobile && (
                <FontAwesomeIcon
                  icon={regular("times")}
                  style={{ fontSize: "20px" }}
                  className="text-white"
                />
              )}
            </div>
            <div className="cm-task-timeline-title text-end">
              <div className="cm-col1 cm-sm-txt d-flex align-items-center justify-content-end text-blue-gray-500 fw-medium cm-xs-txt">
                <FontAwesomeIcon icon={regular("calendar-range")} />
                <p className="my-0 text-uppercase">{t("event_timeline")}</p>
              </div>
              <div className="cm-col2">
                <p className="my-0 text-blue-gray-700 cm-sm-txt">
                  {t("today")} /{" "}
                  <span className="text-blue-gray-500">
                    {moment().format("MMM DD YYYY")}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center text-blue-gray-700 cm-timeline-tab-title mt-3 pe-4">
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              className="cm-timeline-tab-nav bg-blue-gray-50 col-12"
            >
              <Tab
                label={t("scheduled_tasks")}
                disableRipple
                className="cm-timeline-tab text-blue-gray-700 cm-sm-txt fw-medium text-none col-6 mb-3"
              />
              <Tab
                label={t("other_tasks")}
                disableRipple
                className="cm-timeline-tab text-blue-gray-700 cm-sm-txt fw-medium col-6 mb-3"
              />
            </Tabs>
          </div>
          {!timelineStatus.isLoading ? (
            <div className="cm-task-timeline-content pe-4 position-relative">
              <EventTabPanel value={tabValue} index={0}>
                {!!timelineStatus.data.definedTasks ? (
                  Object.keys(timelineStatus.data.definedTasks).length > 0 ? (
                    loadScheduledTasks()
                  ) : (
                    <div className="cm-empty-container text-center position-absolute">
                      <EmptyData />
                      <p className="my-0 text-blue-700 pt-3 fw-semibold">
                        {t("nothing_to_see")}
                      </p>
                    </div>
                  )
                ) : (
                  <div className="cm-empty-container text-center position-absolute">
                    <ProgressBar />
                  </div>
                )}
              </EventTabPanel>
              <EventTabPanel value={tabValue} index={1}>
                {!!timelineStatus.data.otherTasks ? (
                  !!timelineStatus.data.otherTasks &&
                  timelineStatus.data.otherTasks[0]?.data.length > 0 ? (
                    timelineStatus.data.otherTasks.map((el, index) => (
                      <div className="cm-timeline-item" key={index}>
                        <p className="text-blue-gray-700 fw-semibold cm-xs-txt">
                          {el.title}
                        </p>
                        {el.data.length > 0 ? (
                          el.data.map((innerEl, index) => {
                            return (
                              <div
                                className="cm-timeline-inner-item bg-white position-relative d-flex"
                                key={"inner" + index}
                              >
                                {["HOGAN_ASSESSMENTS","TTE_ASSESSMENTS"].includes(innerEl.taskType) && <form id={"other-task-" + index} target="_blank" />}
                                <div className="flex-grow-1">
                                  <div className="d-flex">
                                    <p className="my-0 cm-sm-txt text-blue-800">
                                      {t(innerEl.taskName)}
                                    </p>
                                    {innerEl.taskControl === "LOCK" ? (
                                      <FontAwesomeIcon
                                        icon={solid("lock")}
                                        className="text-blue-gray-500 mx-2 ps-1"
                                      />
                                    ) : null}
                                  </div>
                                  {!(innerEl?.taskControl === "LOCK" || innerEl?.block) && <p className="cm-xs-txt text-blue-gray-500 mb-0 mt-2">
                                    {showTaskType(innerEl)}
                                 </p>
                                  }
                                </div>
                                {["ASSESSMENT","HOGAN_ASSESSMENTS","TTE_ASSESSMENTS"].includes(innerEl.taskType) ? (
                                  <CustomToolTip
                                    disableTooltip={
                                      innerEl.taskControl === "LOCK" ||
                                      innerEl?.block
                                    }
                                    title={
                                      <p className="mb-0 cm-xs-txt fw-medium">
                                        {testToolBody(innerEl)}
                                      </p>
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={regular(
                                        "arrow-up-right-from-square"
                                      )}
                                      onClick={() => handleOtherTaskClick(innerEl, index)}
                                      className={`${handleOtherTaskClass(innerEl)
                                          ? "cm-disable-icon-color"
                                          : "text-blue-gray-700 bg-blue-gray-50 cm-pointer"
                                      } my-auto cm-sm-txt p-2 cm-btn-radius`}
                                    />
                                  </CustomToolTip>
                                ) : (
                                  <CustomToolTip
                                    disableTooltip={
                                      innerEl.taskControl === "LOCK" ||
                                      innerEl?.block
                                    }
                                    title={
                                      <p className="mb-0 cm-xs-txt fw-medium">
                                        {tooltipBodyForOtherTask()}
                                      </p>
                                    }
                                  >
                                    <div className="my-auto">
                                      {innerEl.taskMode === "OFFLINE" &&
                                      [
                                        "INTERVIEW",
                                        "GROUP_DISCUSSION",
                                      ].includes(innerEl.taskType) ? (
                                        <FontAwesomeIcon
                                          icon={regular("location-dot")}
                                          className={`cm-sm-txt p-2 cm-disable-icon-color`}
                                        />
                                      ) : (
                                        <FontAwesomeIcon
                                          icon={regular(
                                            "arrow-up-right-from-square"
                                          )}
                                          className="cm-disable-icon-color my-auto cm-sm-txt p-2 cm-pointer-none"
                                        />
                                      )}
                                    </div>
                                  </CustomToolTip>
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <div
                            className="cm-timeline-inner-item bg-white position-relative"
                            key={"inner" + index}
                          >
                            <p className="my-0 cm-sm-txt text-blue-800">
                              {t("no_tasks_available")}
                            </p>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="cm-empty-container text-center position-absolute">
                      <EmptyData />
                      <p className="my-0 text-blue-700 pt-3 fw-semibold">
                        {t("nothing_to_see")}
                      </p>
                    </div>
                  )
                ) : (
                  <div className="cm-empty-container text-center position-absolute">
                    <ProgressBar />
                  </div>
                )}
              </EventTabPanel>
            </div>
          ) : (
            <div className="cm-task-timeline-content pe-4 d-flex align-items-center justify-content-center">
              <ProgressBar />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TaskTimelineContainer;
